import MINI_HERO_BANNER from '~/src/config/doubleclick/miniHeroBanner';

export default [
    ...MINI_HERO_BANNER,
];
